import React from "react";
import {
  X,
  MessageCircle,
  Linkedin,
  Radio,
  Youtube,
  Phone,
} from "lucide-react";

const MindshareFooter = () => {
  return (
    <div 
      className="py-8"
      style={{ background: "#FFFFFF" }}
    >
      <div style={{ width: "91.5vw", marginLeft: "auto", marginRight: "auto" }}>
        {/* Goldfish GGBR Logo */}
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "24px" }}>
          <img src="/GOLDFISH GGBR.svg" alt="GOLDFISH GGBR" style={{ width: "100%" }} />
        </div>
        
        {/* Social Links */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
          {/* CMC */}
          <a href="https://coinmarketcap.com/currencies/goldfish-gold/" target="_blank" rel="noreferrer" style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }} title="CoinMarketCap">
            <img src="/cmc.png" alt="CMC" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          </a>
          {/* CoinGecko */}
          <a href="#" style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }} title="CoinGecko">
            <img src="/coingecko.svg" alt="CoinGecko" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          </a>
          {/* DexScreener */}
          <a href="https://dexscreener.com/ethereum/0x75a5a265d21bc89ec130f18edde2b49a4b200dac" target="_blank" rel="noreferrer" style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }} title="DexScreener">
            <img src="/dexscreener.png" alt="DexScreener" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          </a>
          {/* X (Twitter) */}
          <a href="https://x.com/goldfishggbr" target="_blank" rel="noreferrer" style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #1B2464", borderRadius: "4px" }} title="X">
            <X size={16} color="#1B2464" />
          </a>
          {/* Discord */}
          <a href="https://discord.com/invite/goldfish" target="_blank" rel="noreferrer" style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #1B2464", borderRadius: "4px" }} title="Discord">
            <MessageCircle size={16} color="#1B2464" />
          </a>
          {/* LinkedIn */}
          <a href="https://www.linkedin.com/company/goldfishggbr/" target="_blank" rel="noreferrer" style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #1B2464", borderRadius: "4px" }} title="LinkedIn">
            <Linkedin size={16} color="#1B2464" />
          </a>
          {/* YouTube */}
          <a href="https://www.youtube.com/@goldfishggbr" target="_blank" rel="noreferrer" style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #1B2464", borderRadius: "4px" }} title="YouTube">
            <Youtube size={16} color="#1B2464" />
          </a>
          {/* Reddit */}
          <a href="https://www.reddit.com/r/Goldfishgold/" target="_blank" rel="noreferrer" style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #1B2464", borderRadius: "4px" }} title="Reddit">
            <Radio size={16} color="#1B2464" />
          </a>
          {/* Contact Button */}
          <a href="tel:+13052095634" style={{ padding: "6px 12px", border: "1px solid #1B2464", borderRadius: "4px", display: "flex", alignItems: "center", gap: "6px", fontSize: "14px", color: "#1B2464", textDecoration: "none", fontWeight: "500" }} title="Contact">
            <Phone size={16} />
            Contact
          </a>
        </div>
      </div>
    </div>
  );
};

export default MindshareFooter;
